const risks = [
  {
    title: 'ランサムウェア',
    desc: '社内データが暗号化されて使えなくなり、復旧のために多額の身代金を要求されるケースが急増しています。',
    bg: 'bg-red-50',
  },
  {
    title: '情報漏洩',
    desc: '顧客情報や機密資料が外部に流出。信頼失墜だけでなく、損害賠償リスクにもつながります。',
    bg: 'bg-orange-50',
  },
  {
    title: '不正アクセス',
    desc: '社内ネットワークに侵入され、気づかないまま情報を盗まれ続けている事態が各地で発生しています。',
    bg: 'bg-amber-50',
  },
];

const CrisisSection: React.FC = () => (
  <section id="crisis" className="py-24 bg-white overflow-hidden">
    <div className="max-w-5xl mx-auto px-6">
      {/* Heading */}
      <div className="text-center mb-16">
        <span className="inline-block text-sky-600 text-sm font-bold tracking-widest uppercase mb-4">
          現状のリスク
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-800 leading-tight">
          神奈川県内でも<br className="md:hidden" />
          サイバーリスクが高まっています
        </h2>
        <p className="mt-4 text-slate-500 text-base max-w-xl mx-auto leading-relaxed">
          「大企業が狙われる話」は昔の話。今は規模を問わず、地域の中小企業が標的になっています。
        </p>
      </div>

      {/* Risk illustration */}
      <div className="relative rounded-2xl overflow-hidden mb-14 h-56 md:h-72">
        <img
          src="https://public.readdy.ai/ai/img_res/f9b3f2eda0897a8a638b1627e45cd3d2.jpg"
          alt="サイバーリスクのイメージ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 to-slate-900/30 flex items-center px-8 md:px-14">
          <div className="max-w-md">
            <p className="text-red-400 text-xs font-bold tracking-widest uppercase mb-3">WARNING</p>
            <p className="text-white text-2xl md:text-3xl font-bold leading-tight">
              「うちは大丈夫」<br />
              <span className="text-slate-300">は通用しない時代です</span>
            </p>
            <p className="text-slate-300 text-sm mt-4 leading-relaxed">
              セキュリティ対策をしていない中小企業は、攻撃者にとって「狙いやすいターゲット」になっています。
            </p>
          </div>
        </div>
      </div>

      {/* Risk cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {risks.map((r) => (
          <div key={r.title} className="border border-slate-100 rounded-xl p-6 flex flex-col gap-4">
            <div className={`w-full ${r.bg} rounded-xl px-4 py-2 flex-shrink-0`}>
              <p className="font-bold text-slate-800 text-base">{r.title}</p>
            </div>
            <div>
              <p className="text-slate-500 text-sm leading-relaxed">{r.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Local emphasis */}
      <div className="mt-10 bg-slate-50 border border-slate-200 rounded-xl p-6">
        <p className="font-bold text-slate-700 text-sm mb-1">神奈川県でも</p>
        <p className="text-slate-500 text-sm leading-relaxed">
          地域の中小企業を狙ったサイバー攻撃の相談が増えています。「対岸の火事」ではなく、いつ自社が被害を受けてもおかしくない状況です。
          今こそ適切な対策を講じるタイミングです。
        </p>
      </div>
    </div>
  </section>
);

export default CrisisSection;
